import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Style from './PopUpModal.module.scss';

const PopUpModal = ({ buttonText, children, message, onClose = () => null, visibility }) => (
  <div className={classNames([Style.container, visibility && Style.visible])} onClick={onClose}>
    <div className={Style.contents} onClick={e => e.stopPropagation()}>
      <div className={Style.closeButtonContainer}>
        <button className={Style.closeButton} onClick={onClose} />
      </div>
      <div className={Style.infoContainer}>
        {message && <div className={Style.description}>{message}</div>}
        {children}
        {buttonText && (
          <button className={classNames(Style.actionButton)} onClick={onClose} type="button">
            <label className={Style.label}>{buttonText}</label>
          </button>
        )}
      </div>
    </div>
  </div>
);

PopUpModal.propTypes = {
  buttonText: PropTypes.string,
  children: PropTypes.node,
  message: PropTypes.string,
  onClose: PropTypes.func,
  visibility: PropTypes.bool,
};

export default React.memo(PopUpModal);
